import React, { Component } from 'react'
import { injectIntl, FormattedMessage, InjectedIntlProps } from 'react-intl'
import { autobind } from 'core-decorators'
import { Modal } from 'react-bootstrap'
import { IoIosClose } from 'react-icons/io'
import GenevaButton from '../../../shared/components/GenevaButton'
import { IScreenshots } from '../../../models'

require('./styles.scss')

interface IScreenshotOverlayProps extends InjectedIntlProps {
  handleClose: Function
  handleImageSwap: Function
  screenshot: IScreenshots
}

interface IState {
  text: string
}

class ScreenshotOverlay extends Component <IScreenshotOverlayProps> {
  state: IState

  componentDidMount(){
    document.addEventListener('keyup', (e) => {
      if (e.keyCode === 27) this.props.handleClose()
    })
    document.addEventListener('keyup', (e) => {
      if (e.keyCode === 37) this.props.handleImageSwap('left')
    })
    document.addEventListener('keyup', (e) => {
      if (e.keyCode === 39) this.props.handleImageSwap('right')
    })
  }
  
  @autobind
  closeModal() {
    this.props.handleClose()
  }

  render() {
    const { screenshot: { url, text, resolution } } = this.props

    return (
      <Modal
        show
        dialogClassName="screenshotDialog"
      >
        <div className="close-container">
          <GenevaButton className="small plain button float-right">
            <IoIosClose
              size={25}
              onClick={this.closeModal}
            />
          </GenevaButton>
        </div>

        <Modal.Body>

          <img src={url} alt="" />

          <div className="comment-wrapper overlay">

            {text
              ? <label>
                <FormattedMessage
                  id="review-center.screenshot.modal-comment-colon"
                />
                {text}
              </label>

              : null}

            <label className="screen-view">
              <FormattedMessage
                id="review-center.screenshot.modal-screenview"
              />
              {resolution > 1023 ? 'Desktop' : 'Mobile'}
            </label>
          </div>

        </Modal.Body>

      </Modal>)
  }
}

export default injectIntl(ScreenshotOverlay)
